import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { get, useController, useFormContext } from 'react-hook-form';
import { Switch } from '@mantine/core';
import { cn } from '@monorepo/utils';
const ControlledSwitchInput = ({ name, readOnly, control: controlProp, disabled, ...props }) => {
    console.log(`[ControlledSwitch-v2] ${name} component rendering. Disabled: ${disabled}. Props:`, props);
    console.log('🔴 NEW CODE VERSION d69f9c6d - IF YOU SEE THIS, THE NEW CODE IS LOADED');
    // Try to get form context, but handle SSR gracefully
    console.log('🔵 Attempting to get form context...');
    let ctx;
    try {
        ctx = useFormContext();
        console.log('🔵 Form context obtained:', ctx ? 'YES' : 'NO');
    }
    catch (e) {
        // Context not available (SSR or outside FormProvider)
        console.log('🔵 Form context error:', e);
        ctx = null;
    }
    const effectiveControl = ctx?.control ?? controlProp;
    console.log('🔵 Effective control:', effectiveControl ? 'EXISTS' : 'NULL');
    if (!effectiveControl) {
        console.log('🔴 NO CONTROL - Returning uncontrolled fallback');
        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            console.warn(`ControlledSwitchInput "${name}" must be used inside a <FormProvider>. Rendering uncontrolled fallback.`);
        }
        return _jsx(Switch, { ...props, readOnly: readOnly, disabled: disabled });
    }
    console.log('🟢 Control exists, continuing with controlled component');
    const { formState: { errors, isLoading, isSubmitting }, } = ctx || { formState: { errors: {}, isLoading: false, isSubmitting: false } };
    console.log('🟡 Step 1: About to get error from form state');
    const error = useMemo(() => get(errors, name)?.message, [errors, name]);
    console.log('🟡 Step 2: About to call useController for field:', name);
    const { field } = useController({ name, control: effectiveControl });
    console.log('🟡 Step 3: useController completed. Field:', field);
    const classNames = props.classNames;
    console.log(`🟡 Step 4: [ControlledSwitch] ${name} field value:`, field.value, 'checked will be:', !!field.value);
    const handleChange = (e) => {
        console.log(`[ControlledSwitch] ${name} onChange HANDLER CALLED! Disabled: ${disabled}, Current: ${field.value}, New: ${e.target.checked}`);
        if (disabled) {
            console.log(`[ControlledSwitch] ${name} onChange blocked due to disabled`);
            return;
        }
        console.log(`[ControlledSwitch] ${name} calling field.onChange with:`, e.target.checked);
        field.onChange(e.target.checked);
        console.log(`[ControlledSwitch] ${name} field.onChange called successfully`);
    };
    console.log(`[ControlledSwitch] ${name} about to render Switch with onChange handler:`, handleChange);
    return (_jsx(Switch, { ...props, error: error, "aria-invalid": !!error, checked: !!field.value, onChange: handleChange, readOnly: readOnly || isLoading || isSubmitting, disabled: disabled || undefined, classNames: {
            ...classNames,
            input: cn('peer', classNames?.input),
        } }));
};
export default ControlledSwitchInput;
